import { useState } from "react";
import { faqs } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于下载、缓存与离线观看的常见疑问"
          description="下面整理了大家在下载安装、缓存视频与离线观看过程中最常问到的问题，点击标题即可展开查看解答。"
        />

        <div className="mt-9 space-y-3 md:mt-12">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 p-5 text-left md:p-6"
                >
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}></i>
                  </span>
                </button>
                <div
                  className={`border-t border-background-200 px-5 pb-5 pt-4 md:px-6 md:pb-6 ${
                    isOpen ? "block" : "hidden"
                  }`}
                >
                  <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}